import {
  getFirstSelectedInvoiceStream,
  getFirstSelectedInvoiceStreamId,
} from '@/shared/components/registration/registrationHelpers';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('InvoiceStreamSettingsDialogCtrl', [
    'resourceFactorySvc',
    'ModalService',
    'dataCache',
    'checkSecurity',
    '$translate',
    'translateListFilter',
    'flySvc',
    '$element',
    'close',
    'invoicestream',
    'relation',
    'forInvoicingVia',
    invoiceStreamSettingsDialogCtrl,
  ]);

function invoiceStreamSettingsDialogCtrl(
  resourceFactorySvc,
  ModalService,
  dataCache,
  checkSecurity,
  $translate,
  translateListFilter,
  flySvc,
  $element,
  close,
  invoicestream,
  relation,
  forInvoicingVia,
) {
  var vm = this;
  vm.saving = false;
  vm.hasInvoiceTeamAccess = checkSecurity('InvoiceDraft:r') && relation.hasInvoiceTeamAccess;
  vm.readOnly = !checkSecurity('InvoiceDraft:u') || !relation.hasInvoiceTeamAccess;
  vm.invoicestream = angular.copy(invoicestream);
  if (!vm.invoicestream.startDate) {
    vm.invoicestream.startDate = moment
      .utc()
      .startOf('day')
      .toDate();
  }
  vm.isInvoicingVia = forInvoicingVia;
  vm.originalHasInvoicingVia = false;
  vm.schedule = null;
  vm.schedules = null;
  const lastYear = moment
    .utc()
    .startOf('day')
    .subtract(1, 'years');
  vm.datepickerOptions = {
    minDate: moment.utc(vm.invoicestream.startDate).isBefore(lastYear, 'day')
      ? vm.invoicestream.startDate
      : lastYear.toDate(),
    startingDay: 1,
  };
  vm.showValidation = false;

  var originalInvoicingType = vm.invoicestream.schedule
    ? vm.invoicestream.schedule.invoicingType
    : null;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  vm.loadSchedules = function() {
    return resourceFactorySvc.get('invoiceSchedule').query(
      {},
      function(data) {
        vm.schedules = [
          {
            key: '0',
            label: $translate.instant('No invoice schedule'),
          },
          ...data
            .map(x => {
              const name = translateListFilter(x.id, 'invoiceSchedule', x.name);
              const invType = translateListFilter(x.invoicingType, 'invoicingType');
              return {
                ...x,
                key: `2;${x.id}`,
                label: `${name}          (${invType})`,
              };
            })
            .sort(dynamicSort('label')),
        ];

        if (invoicestream.invoicingViaRelation) {
          vm.schedule = null;
          vm.isInvoicingVia = true;
          vm.originalHasInvoicingVia = true;
        } else if (invoicestream.schedule) {
          vm.schedule = vm.schedules.find(x => x.key === `2;${invoicestream.schedule.id}`);
        } else {
          vm.schedule = vm.schedules.find(x => x.key === '0');
        }
      },
      showError,
    ).$promise;
  };
  vm.loadSchedules();

  var updateInvoiceStream = function(invoicestream) {
    vm.saving = true;
    resourceFactorySvc
      .get('invoiceStream')
      .update(invoicestream)
      .$promise.then(
        function(response) {
          if (response) {
            flySvc.success('msgConfirmChange');
            if (vm.invoicestream.startDate > new Date())
              flySvc.message('msgInvoiceScheduleExistingLinesBeforeStartDateNotDeleted');
            close(response, 500);
            $element.modal('hide');
            vm.saving = false;
          }
          return false;
        },
        function(error) {
          showError(error);
          vm.saving = false;
        },
      );
  };

  vm.save = function() {
    if (vm.saving) return '';
    var invoicestream = angular.copy(vm.invoicestream);

    //Show warning message if previous invoicing type was advance/settlement and has now changed and if the schedule should start today
    if (
      originalInvoicingType === 2 &&
      (!invoicestream.schedule || invoicestream.schedule.invoicingType !== 2)
    ) {
      if (vm.hasUnsettledAdvances === null) return ''; //Still retrieving unsettled invoices
      if (vm.hasUnsettledAdvances) {
        return ModalService.showModal({
          template: require('./invoiceMethodChangedDialog.html'),
          controller: 'InvoiceMethodChangedDialogCtrl',
          controllerAs: 'vm',
          locationChangeSuccess: false,
          inputs: {
            advances: vm.hasUnsettledAdvances,
          },
        }).then(function(modal) {
          modal.element.modal();
          modal.element.on('hidden.bs.modal', function(e) {
            modal.element.off(e); //Remove event
            modal.element.remove(); //Remove element
          });
          modal.close.then(function(result) {
            if (result === null) return false;
            invoicestream.removeUnsettledAdvances = !!result;
            return updateInvoiceStream(invoicestream);
          });
        });
      }
    }

    return updateInvoiceStream(invoicestream);
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.validateTemplate = function() {
    if (vm.isInvoicingVia) {
      if (!vm.invoicestream.invoicingViaRelation?.id) return false;
      if (!vm.invoicestream.invoicingViaStream?.id) return false;
    } else if (!vm.schedule) return false;

    var invoicingType = vm.invoicestream.schedule ? vm.invoicestream.schedule.invoicingType : null;
    if (invoicingType && (invoicingType == 1 || invoicingType == 2) && !vm.invoicestream.amount) {
      // vm.showValidation = true;
      return false;
    }
    if (!vm.invoicestream.startDate) {
      return false;
    }
    vm.showValidation = false;
    return true;
  };

  vm.hasUnsettledAdvances = null;
  vm.scheduleChanged = function() {
    const companySettings = null;
    let defaultLedger = '';

    if (!vm.schedule || vm.schedule.key === '0') {
      vm.invoicestream.schedule = null;
      vm.invoicestream.invoicingViaRelation = null;
      vm.invoicestream.invoicingViaStream = null;
    } else {
      vm.invoicestream.schedule = vm.schedule;
      vm.invoicestream.invoicingViaRelation = null;
      vm.invoicestream.invoicingViaStream = null;
    }

    if (vm.invoicestream.schedule) {
      const companyId = vm.invoicestream.companyId ?? relation.companyId;
      if (vm.invoicestream.schedule.invoicingType === 1) {
        defaultLedger = dataCache.getCompanySettings(companyId).fixedAmountLedgerAccount;
      }
      if (vm.invoicestream.schedule.invoicingType === 2) {
        defaultLedger = dataCache.getCompanySettings(companyId).advanceSettlementLedgerAccount;
      }
    }
    vm.invoicestream.ledgerAccount = defaultLedger;
    vm.datepickerOptions.minDate = lastYear.toDate();
    vm.invoicestream.startDate = null;

    //Retrieve unsettled advances if old schedule was advance/settlement
    if (
      vm.hasUnsettledAdvances === null &&
      originalInvoicingType === 2 &&
      (!vm.invoicestream.schedule || vm.invoicestream.schedule.invoicingType !== 2)
    ) {
      resourceFactorySvc.get('invoiceStream').unsettledAdvances(
        { id: vm.invoicestream.id },
        function({ amount = 0, invoiceIds = [] }) {
          if (invoiceIds.length) {
            vm.hasUnsettledAdvances = { amount, invoiceIds, count: invoiceIds.length };
          } else {
            vm.hasUnsettledAdvances = false;
          }
        },
        showError,
      );
    }
  };

  vm.invoicingViaRelationChanged = function() {
    if (!vm.invoicestream.invoicingViaRelation) {
      vm.invoicestream.invoicingViaStream = null;
      return;
    }
    if (vm.invoicestream.invoicingViaRelation.invoiceStreams) {
      const id =
        vm.invoicestream.invoicingViaStream?.id ??
        getFirstSelectedInvoiceStreamId(vm.invoicestream.invoicingViaRelation);
      vm.invoicestream.invoicingViaStream = vm.invoicestream.invoicingViaRelation.invoiceStreams.find(
        x => x.id === id,
      );
    }
  };

  vm.clearInvoicingVia = function() {
    vm.invoicestream.schedule = null;
    vm.invoicestream.invoicingViaRelation = null;
    vm.invoicestream.invoicingViaStream = null;
    vm.save();
  };
}
